import ICustomizablePricing from "../contracts/ICustomizablePricing";
import PricingHandler from "../contracts/PricingHandler";

/**
 * Assigns price to minimum customization price when provided.
 *
 * @param input
 * @param resolvedPricing
 */
const customizableHandler: PricingHandler<ICustomizablePricing> = (
  input,
  resolvedPricing,
) => {
  if (!input.isCustomizable) return resolvedPricing;

  return {
    ...resolvedPricing,
    metadata: {
      ...resolvedPricing.metadata,
      customizable: true,
      requiresCustomization: input.requiresCustomization,
    },
    price: input.minimumCustomizationPrice || resolvedPricing.price,
  };
};

export default customizableHandler;
